// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"kwGcS","rc-tabs-tab":"wTG0l","rc-tabs-tab-active":"B50hT","tip":"r0wun","tip-label":"bHBdt","tip-group":"_30UIR","fieldItem":"VeEiV"};